import React from "react";
import { MdSearch, MdClose } from "react-icons/md";

import classes from "./Search.module.scss";

type Props = {
  onChange: (value: string) => void;
  clear: () => void;
  placeHolder?: string;
  value: string;
};

export const Search: React.FC<Props> = ({
  onChange,
  clear,
  placeHolder = "Введите текст для поиска",
  value,
}) => {
  return (
    <div className={classes.Container}>
      <MdSearch size={32} className={classes.SearchIcon} />
      <input
        onChange={(e) => onChange(e.target.value)}
        value={value}
        className={classes.Input}
        placeholder={placeHolder}
      />
      {value.length > 0 && (
        <button type="button" className={classes.ClearAnchor} onClick={clear}>
          <MdClose size={24} className={classes.ClearIcon} />
        </button>
      )}
    </div>
  );
};
